import { FileBrowserPagination, FileBrowserProvider } from 'app/domains/filesystem';
import { FileBrowserEntries } from './FileBrowserEntries';
export function MetadataFileBrowser(props) {
    const { handleSelect } = props;
    return (<FileBrowserProvider limit={20}>
      <FileBrowserEntries handleSelect={handleSelect}/>
      <FileBrowserPagination />
    </FileBrowserProvider>);
}
